export const ProductType = {
  PRODUCT: 1,
  CHEMICAL_PRODUCT: 2,
  CHEMICAL: 3,
};
